import request from '@/utils/request';
import router from '@/router';

/* eslint-disable */
const actions = {
  async addProduct({ dispatch, commit }, product) {
    try {
      const { data } = await request.post('products', product);

      if (data.error) {
        throw Error('Server-side validation failed');
      }

      router.push({ name: "products.edit", params: { uuid: data.product.uuid } });
    } catch (err) {
      throw err;
    }
  },
};

export default actions;
